module.exports = __webpack_public_path__ + "img/bag.134ade08.png";